import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '@/components/LazyRoute'
import { SimplePageLoader } from '@/components/ui/page-loader'

export const Route = createFileRoute('/_protected/organization/settings/signing-secret')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/organization-settings/signing-secret')}
      fallback={<SimplePageLoader />}
    />
  ),
})
